// @storybook-skip: app wrapper for shared `MaintenanceView` component
import { useAppStore } from "@hooks/useAppStore";
import { isAndroid, isIOS } from "@memorang/helpers/platform";
import MaintenanceView from "@memorang/ui/components/MaintenanceView";
import { Linking } from "react-native";

const getStoreUrl = (urls?: { ios?: string; android?: string }) => {
	if (isIOS) {
		return urls?.ios;
	}
	if (isAndroid) {
		return urls?.android;
	}
	return undefined;
};

const MaintenanceViewContainer = () => {
	const maintenance = useAppStore((state) => state.app?.maintenance);
	const storeUrl = getStoreUrl(maintenance?.urls);

	return (
		<MaintenanceView
			title={maintenance?.title ?? ""}
			subtitle={maintenance?.subtitle ?? ""}
			ctaLabel={storeUrl ? "Update app" : undefined}
			onPressCta={storeUrl ? () => Linking.openURL(storeUrl) : undefined}
		/>
	);
};

export default MaintenanceViewContainer;
